module.exports = __webpack_public_path__ + "img/int8_rel_esc_02.5b51e313.jpg";